import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { PortalSettingsService } from '../services/portal-settings.service';

export const anonPortalSettingsResolver: ResolveFn<any> = () => {
  let portalSettingsService = inject(PortalSettingsService);
  let http = inject(HttpClient);
  if (portalSettingsService.getPortalSettings() == null) {
    return http.get('/Account/GetPortalSettingsAnon')
      .toPromise()
      .then((response) => {
        portalSettingsService.setPortalSettings(response);
      });
  }
}
